var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDownload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14C20.4 14 20 14.4 20 15V19C20 19.6 19.6 20 19 20H5C4.4 20 4 19.6 4 19V15C4 14.4 3.6 14 3 14C2.4 14 2 14.4 2 15V19C2 20.7 3.3 22 5 22H19C20.7 22 22 20.7 22 19V15C22 14.4 21.6 14 21 14ZM11.3 15.7C11.4 15.8 11.5 15.9 11.6 15.9C11.7 16 11.9 16 12 16C12.1 16 12.3 16 12.4 15.9C12.5 15.8 12.6 15.8 12.7 15.7L17.7 10.7C18.1 10.3 18.1 9.7 17.7 9.3C17.3 8.9 16.7 8.9 16.3 9.3L13 12.6V3C13 2.4 12.6 2 12 2C11.4 2 11 2.4 11 3V12.6L7.7 9.3C7.3 8.9 6.7 8.9 6.3 9.3C5.9 9.7 5.9 10.3 6.3 10.7L11.3 15.7Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconDownload.10c45e93c03e94283055a0898d23244f.svg";